import { useI18n } from 'vue-i18n';
import messages from './i18n/en.json';
import ptBRMessages from './i18n/pt_BR.json';

export const useAdsI18n = () =>
  useI18n({
    useScope: 'local',
    fallbackLocale: 'en',
    messages: { en: messages, pt_BR: ptBRMessages, 'pt-BR': ptBRMessages },
  });
